export const POSITION = {
  BOTTOM: 'bottom',
  CENTER: 'center',
  IN_LINE: 'in-line',
  TOP: 'top',
}

export const TYPE = {
  BIG: 'big',
  SMALL: 'small',
}

export const ALIGN = {
  CENTER: 'center',
  END: 'end',
  START: 'start',
}
